import { render, staticRenderFns } from "./perfilesEdit.vue?vue&type=template&id=2e710475&"
import script from "./perfilesEdit.vue?vue&type=script&lang=js&"
export * from "./perfilesEdit.vue?vue&type=script&lang=js&"
import style0 from "./perfilesEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports